import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import baseReducers from './Reducers/Index.js'
import Registry from './Registry/Registry.js'
import registryMiddleware from './Registry/Middleware.js'
import { createLogger } from 'redux-logger'
import persistState from 'redux-localstorage';

export default function createStore(initialState = {}) {
    let middleWareTools = undefined;
    const logger = createLogger({
        collapsed: true,
        level: 'log',
        diff: true
    });

    const registry = new Registry(baseReducers);
    let middlewares = [];
    middlewares.push(registryMiddleware(registry));
    middlewares.push(thunkMiddleware);

    middleWareTools = compose(
        applyMiddleware(...middlewares),
        persistState(null, { key: 'maxwell' })
    );

    let finalCreateStore = middleWareTools;

    const store = finalCreateStore(_createStore)(
        registry.initialReducers,
        initialState
    )

    registry.store = store

    return store
}
